import opacosPhoto from "@/assets/opacos-fc.webp";
import opacosCrest from "@/assets/opacos-fc-crest.png";
import atleticCrest from "@/assets/atletic-gironi-crest.png";
import gorilaCrest from "@/assets/el-baile-del-gorila-crest.png";
import galacticosCrest from "@/assets/galacticos-crest.png";
import sefCrest from "@/assets/sef-academy-crest.png";

// Datos extra por equipo (fotos, escudos, overrides) que viajan con el código
// y por tanto funcionan también en producción tras redeploy.
export const TEAM_EXTRAS = {
  "athletic-gironi": {
    name: "ATLÈTIC GIRONÍ",
    captain_name: "JONI",
    crest: atleticCrest,
  },
  "opacos-fc": {
    captain_name: "BEAU",
    photo: opacosPhoto,
    crest: opacosCrest,
  },
  "el-baile-del-gorila": {
    captain_name: "PAU",
    crest: gorilaCrest,
  },
  "galacticos": {
    captain_name: "ROBERTO",
    crest: galacticosCrest,
  },
  "sef-academy": {
    captain_name: "EDU",
    crest: sefCrest,
  },
};
